import './store_button.css';

const StoreButton = ({ icon, storeName, url = "#", textTop = "Disponível em", ariaLabel }) => {
    return (
        <a href={url} className="store-button" target="_blank" rel="noopener noreferrer" aria-label={ariaLabel}>
            <div className="store-icon">
                <img src={icon} alt={`${storeName} icon`} />
            </div>
            <div className="store-text">
                <span className="text-small">{textTop}</span>
                <span className="text-large">{storeName}</span>
            </div>
        </a>
    );
};

export default StoreButton;
